export default {"src":"/_next/static/media/powered-stripe-dark.d355ed8d.svg","height":34,"width":150};